<form #companyForm="ngForm">
  <div
    id="sso-settings"
    class="settings-page-container"
    rvSpinner="sso-settings"
    [rvShowSpinner]="loading"
  >
    <div class="settings-page-body">
      @if (formError) {
        <div
          class="alert alert-danger tw-mt-[30px] tw-mx-[30px] tw-mb-0"
          role="alert"
        >
          {{ formError }}
        </div>
      }
      <div class="settings-page-section">
        <div class="tw-w-full">
          <div class="tw-flex left-right-aligner tw-pt-[25px]">
            <label
              id="company-settings-sso-enabled-label"
              for="company-settings-sso-enabled"
              class="control-label tw-text-base tw-font-semibold"
              (click)="
                company.settings.ssoEnabled = !company.settings.ssoEnabled;
                onSSOEnabledChange()
              "
            >
              Enable SAML Single Sign On (SSO)
            </label>
            <mat-slide-toggle
              class="mb-2"
              name="ssoEnabled"
              id="company-settings-sso-enabled"
              [(ngModel)]="company.settings.ssoEnabled"
              aria-labelledby="company-settings-sso-enabled-label"
              (change)="onSSOEnabledChange()"
              [attr.aria-pressed]="company.settings.ssoEnabled"
            >
            </mat-slide-toggle>
          </div>

          @if (!company.settings.ssoEnabled) {
            <div
              class="tw-w-full tw-text-1xl tw-mt-[2.5px] tw-mb-5 tw-border-0 tw-border-t tw-border-solid tw-border-gray-200 tw-mt-[25px] tw-pt-[25px]"
            >
              Use the following information to create an application within your
              Identity Provider.
            </div>
            <div
              class="tw-flex md:!tw-flex-row tw-flex-col tw-gap-2.5 tw-w-full tw-pt-[5px] tw-pb-[5px]"
            >
              <div class="tw-w-full">
                <label class="control-label tw-text-[15px]"
                  >Assertion Consumer Service URL:</label
                >
                <div class="tw-flex tw-gap-[5px] tw-items-center tw-mt-[5px]">
                  <span type="text" class="tw-truncate">
                    {{ company.settings.ssoSpUrl }}
                  </span>
                  <button
                    class="btn btn-default-icon tw-border-0"
                    (click)="copyAcsUrl()"
                    aria-label="Copy Assertion Consumer Service URL"
                  >
                    <streamline-icon
                      aria-label="Copy Assertion Consumer Service URL"
                      name="copy"
                      width="10"
                      height="10"
                    ></streamline-icon>
                  </button>
                </div>
              </div>
              <div class="tw-w-full">
                <label class="control-label tw-text-[15px]"
                  >Service Provider Entity ID:</label
                >
                <div class="tw-flex tw-gap-[5px] tw-items-center tw-mt-[5px]">
                  <span type="text" readonly class="tw-truncate">
                    {{ company.settings.ssoSpId }}
                  </span>
                  <button
                    class="btn btn-default-icon tw-border-0"
                    (click)="copySpId()"
                    aria-label="Copy Service Provider Entity ID"
                  >
                    <streamline-icon
                      aria-label="Copy Service Provider Entity ID"
                      name="copy"
                      width="10"
                      height="10"
                    ></streamline-icon>
                  </button>
                </div>
              </div>
            </div>
          } @else {
            <div
              class="tw-flex md:!tw-flex-row tw-flex-col tw-gap-2.5 tw-w-full tw-mt-[25px] tw-pt-[25px] tw-pb-[25px] tw-border-0 tw-border-t tw-border-solid tw-border-gray-200"
            >
              <div class="tw-w-full tw-flex tw-flex-col">
                <label class="control-label tw-text-[15px]">
                  SSO Provider ID
                </label>
                <input
                  class="form-control tw-truncate"
                  [disabled]="!company.settings.ssoEnabled"
                  name="ssoIdpId"
                  #ssoIdpId="ngModel"
                  [(ngModel)]="company.settings.ssoIdpId"
                  required
                  [pattern]="entityIdPattern"
                />
                <p
                  [shown]="
                    (ssoIdpId.dirty || companyForm?.submitted) &&
                    ssoIdpId.errors?.required
                  "
                  class="help-block validation-error-message-name text-danger"
                >
                  Identity Provider ID is required.
                </p>
                <p
                  [shown]="
                    (ssoIdpId.dirty || companyForm?.submitted) &&
                    ssoIdpId.errors?.pattern
                  "
                  class="help-block validation-error-message-name text-danger"
                >
                  Please enter a valid URI.
                </p>
              </div>

              <div class="tw-w-full tw-flex tw-flex-col">
                <label class="control-label tw-text-[15px]">
                  SSO Provider URL
                </label>
                <input
                  class="form-control tw-truncate"
                  [disabled]="!company.settings.ssoEnabled"
                  name="ssoIdpUrl"
                  #ssoIdpUrl="ngModel"
                  [(ngModel)]="company.settings.ssoIdpUrl"
                  required
                  [pattern]="urlPattern"
                />
                <p
                  [shown]="
                    (ssoIdpUrl.dirty || companyForm?.submitted) &&
                    ssoIdpUrl.errors?.required
                  "
                  class="help-block validation-error-message-name text-danger"
                >
                  Identity Provider URL is required.
                </p>
                <p
                  [shown]="
                    (ssoIdpUrl.dirty || companyForm?.submitted) &&
                    ssoIdpUrl.errors?.pattern
                  "
                  class="help-block validation-error-message-name text-danger"
                >
                  Please enter a valid URL.
                </p>
              </div>

              <!-- X.509 Certificate Section -->
              <div class="tw-w-full">
                <label
                  for="company-settings-ssoidpcertificate"
                  class="control-label tw-text-[15px]"
                >
                  X.509 Certificate
                </label>
                @if (certificateEditable) {
                  <div>
                    <textarea
                      id="company-settings-ssoidpcertificate"
                      name="company-settings-ssoidpcertificate"
                      #ssoIdpCertificate="ngModel"
                      required
                      [pattern]="certificatePattern"
                      type="text"
                      rows="4"
                      class="form-control"
                      [(ngModel)]="company.settings.ssoIdpCertificate"
                      [disabled]="!company.settings.ssoEnabled"
                    >
                    </textarea>
                    <p
                      [shown]="
                        (ssoIdpCertificate.dirty || companyForm?.submitted) &&
                        ssoIdpCertificate.errors?.required
                      "
                      class="help-block validation-error-message-name text-danger"
                    >
                      Identity Provider x509 Certificate is required.
                    </p>
                    <p
                      [shown]="
                        (ssoIdpCertificate.dirty || companyForm?.submitted) &&
                        ssoIdpCertificate.errors?.pattern
                      "
                      class="help-block validation-error-message-name text-danger"
                    >
                      Please enter a valid X.509 certificate. It should start
                      with "-----BEGIN CERTIFICATE-----" and end with "-----END
                      CERTIFICATE-----"
                    </p>
                  </div>
                } @else {
                  <div class="tw-flex left-right-aligner">
                    <input
                      id="company-settings-ssoidpcertificate-label"
                      name="company-settings-ssoidpcertificate-label"
                      #ssoIdpCertificate="ngModel"
                      type="text"
                      class="form-control"
                      [(ngModel)]="company.settings.ssoIdpCertificate"
                      readonly
                    />
                    <button
                      class="btn btn-default-icon pl-3 pr-3 ml-2 tw-mr-[2.5px]"
                      aria-label="Edit X.509 Certificate"
                      (click)="editCertificate()"
                      [disabled]="!company.settings.ssoEnabled"
                    >
                      <streamline-icon
                        name="pencil"
                        width="12"
                        height="12"
                      ></streamline-icon>
                    </button>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <div
          class="tw-w-full tw-pt-[25px] tw-pb-[25px] tw-border-0 tw-border-t tw-border-solid tw-border-gray-200"
          [hidden]="!company.settings.ssoEnabled"
        >
          <div class="tw-flex left-right-aligner">
            <label
              id="company-settings-sso-cascade-label"
              for="company-settings-sso-cascade"
              class="control-label tw-text-base tw-font-semibold"
              (click)="
                company.settings.ssoCascadeConfiguration =
                  !company.settings.ssoCascadeConfiguration
              "
            >
              Cascade to sub-company
            </label>
            <mat-slide-toggle
              class="mb-2"
              name="ssoCascadeConfiguration"
              id="company-settings-sso-cascade"
              aria-labelledby="company-settings-sso-cascade-label"
              [(ngModel)]="company.settings.ssoCascadeConfiguration"
              [disabled]="!company.settings.ssoEnabled"
              [attr.aria-pressed]="company.settings.ssoCascadeConfiguration"
            >
            </mat-slide-toggle>
          </div>
        </div>

        <div
          class="tw-w-full tw-pt-[25px] tw-pb-[25px] tw-border-0 tw-border-b tw-border-t tw-border-solid tw-border-gray-200"
          [hidden]="!company.settings.ssoEnabled"
        >
          <div class="tw-flex left-right-aligner">
            <label
              id="company-settings-ssorequired-label"
              for="company-settings-ssorequired"
              class="control-label tw-text-base tw-font-semibold"
              (click)="
                company.settings.ssoRequired = !company.settings.ssoRequired;
                onSSORequiredChange()
              "
            >
              Require SSO for all users
            </label>
            <mat-slide-toggle
              class="mb-2"
              name="ssoRequired"
              id="company-settings-ssorequired"
              aria-labelledby="company-settings-ssorequired-label"
              [(ngModel)]="company.settings.ssoRequired"
              [disabled]="!company.settings.ssoEnabled"
              (change)="onSSORequiredChange()"
              [attr.aria-pressed]="company.settings.ssoRequired"
            >
            </mat-slide-toggle>
          </div>
        </div>

        <div
          class="tw-w-full tw-pt-[25px]"
          [hidden]="!company.settings.ssoEnabled"
        >
          <div class="tw-flex left-right-aligner">
            <label
              id="company-settings-sso-user-provisioning-label"
              for="company-settings-sso-user-provisioning"
              class="control-label tw-text-base tw-font-semibold"
              (click)="
                company.settings.ssoUserProvisioningEnabled =
                  !company.settings.ssoUserProvisioningEnabled
              "
            >
              Enable SSO User Provisioning
            </label>
            <mat-slide-toggle
              name="ssoUserProvisioningEnabled"
              aria-labelledby="company-settings-sso-user-provisioning-label"
              [(ngModel)]="company.settings.ssoUserProvisioningEnabled"
              [disabled]="
                !company.settings.ssoEnabled || !company.settings.ssoRequired
              "
              id="company-settings-sso-user-provisioning"
              [attr.aria-pressed]="company.settings.ssoUserProvisioningEnabled"
            >
            </mat-slide-toggle>
          </div>
          <div class="tw-text-1xl tw-text-gray-500 tw-mt-[2.5px] tw-mb-5">
            Enabling this setting manages users through your IdP and requires
            SSO for all users. <br />
          </div>
          <div
            class="tw-text-1xl tw-text-gray-500 tw-mt-[2.5px] tw-mb-5"
            [hidden]="!company.settings.ssoUserProvisioningEnabled"
          >
            Please confirm that all users have the appropriate user roles
            assigned through the IdP. Users who do not have user roles will not
            have access to Rise Vision. <br />
            <a
              rv-link
              appearance="inline"
              target="_blank"
              href="https://help.risevision.com/hc/en-us/articles/14653732546580-How-do-I-enable-Single-Sign-On-for-Rise-Vision"
              >Learn more about SSO User Provisioning</a
            >
          </div>

          <notification-alert
            title="First time user login instructions."
            type="info"
            class="tw-text-1xl tw-leading-loose"
            [hidden]="!company.settings.ssoUserProvisioningEnabled"
          >
            When logging in for the first time your users will need to sign in
            through your IdP portal or you can instruct them to use the
            following url: <br />
            <div class="tw-flex tw-items-center tw-gap-[5px]">
              <input
                type="text"
                [value]="loginUrl"
                class="form-control tw-w-2/4 tw-h-[25px] tw-rounded-none tw-bg-black/5 tw-border-0 tw-truncate"
                readonly
              />
              <a rv-link class="tw-ml-2.5" (click)="copyLoginUrl()">Copy URL</a>
            </div>
          </notification-alert>
        </div>
      </div>
    </div>
    <div class="settings-page-footer">
      <common-actions [actions]="actions" [saving]="loading"> </common-actions>
    </div>
  </div>
</form>
